import { useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { ArrowRight } from 'lucide-react';

const PublicNavbar = () => {
  const navigate = useNavigate();

  return (
    <nav className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[95%] max-w-6xl bg-white/95 backdrop-blur-md border border-gray-200 rounded-2xl shadow-xl shadow-gray-200/50 transition-all duration-300" data-testid="navbar">
      <div className="px-4 sm:px-6 h-14 flex items-center justify-between">
        {/* Logo */}
        <div className="cursor-pointer" onClick={() => navigate('/')}>
          <Logo size="sm" />
        </div>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-1 text-sm font-medium text-gray-500">
          <button onClick={() => navigate('/pricing')} className="px-3.5 py-1.5 rounded-lg hover:bg-gray-100 hover:text-gray-900 transition-colors">Pricing</button>
          <button onClick={() => navigate('/login')}   className="px-3.5 py-1.5 rounded-lg hover:bg-gray-100 hover:text-gray-900 transition-colors">Log in</button>
        </div>

        {/* CTA */}
        <button
          onClick={() => navigate('/signup')}
          data-testid="nav-cta-btn"
          className="flex items-center justify-center gap-1.5 min-h-[40px] bg-[#064E3B] text-white text-xs font-bold px-4 rounded-lg hover:bg-[#065f46] transition-colors shadow-sm shadow-[#064E3B]/20"
        >
          Get Started <ArrowRight className="w-4 h-4" strokeWidth={2.5} />
        </button>
      </div>
    </nav>
  );
};

export default PublicNavbar;
